import { BaseApi } from '@shared/config';
import type { ActivitySphere, GetActivitySpheresResponse } from './types';

class ActivitySphereApi extends BaseApi {
  getActivitySpheres = (
    params: GetActivitySpheresResponse
  ): Promise<ActivitySphere[]> => {
    return this.instance.get('/activity-spheres', { params });
  };
}

export const activitySphereApi = new ActivitySphereApi();
